//@flow
import React from 'react'
import classnames from 'classnames'

import { Flex, Label } from '..'
import { useI18n } from '~/core/i18n'
import { useUploadStyles, useFileTileStyles } from './styles'

type FileTileProps = {
  name?: string,
  accept?: string,
  isUpload?: boolean,
  isMulti?: boolean,
  onRemove?: () => void,
  onFileChange?: (event: SyntheticInputEvent<HTMLInputElement>) => void
}

const FileTile = ({
  accept = '*',
  name = '',
  isUpload,
  isMulti,
  onRemove = () => {},
  onFileChange = () => {}
}: FileTileProps) => {
  const [msg] = useI18n()
  const classes = useFileTileStyles()
  return (
    <Flex
      alignCenter
      as={isUpload ? 'label' : 'div'}
      className={classnames(classes.fileTileWrapper, {
        upload: isUpload
      })}
      column
      htmlFor={isUpload ? 'upload-file' : undefined}
      justifyCenter
      title={isUpload ? msg('common.upload.chooseFile') : name}
    >
      <i className="icon icon-m">{isUpload ? 'upload' : 'file'}</i>
      {isUpload ? (
        <>
          <input
            accept={accept}
            id="upload-file"
            multiple={isMulti}
            name="upload-file"
            type="file"
            onChange={onFileChange}
          />
          <span className="upload-file">{msg('common.upload.load')}</span>
        </>
      ) : (
        <>
          <span className="filename">{name}</span>
          <i
            className="icon icon-s remove"
            id={`file-remove-${name}`}
            title={msg('common.upload.removeFile')}
            onClick={onRemove}
          >
            close
          </i>
        </>
      )}
    </Flex>
  )
}

type UploadProps = {
  accept?: string,
  value?: File[],
  label?: string,
  isMulti?: boolean,
  wrapperProps?: {
    [key: string]: any
  },
  onChange?: (files: File[]) => void
}

const Upload = ({ accept, label, isMulti, value, wrapperProps, onChange = () => {} }: UploadProps) => {
  const classes = useUploadStyles()
  const files = Array.isArray(value) ? value : []

  const handleFileChange = ({ target }) => {
    const newFiles = [...target.files].filter(({ name: newName }) => !files.some(({ name }) => newName === name))
    return onChange([...files, ...newFiles])
  }

  const handleRemoveFile = name => {
    const newFiles = files.filter(file => file.name !== name)
    return onChange(newFiles)
  }

  return (
    <Flex alignCenter className={classes.uploadWrapper} column {...wrapperProps}>
      {label && <Label>{label}</Label>}
      <Flex wrap>
        {files.map(({ name }) => (
          <FileTile key={name} name={name} onRemove={() => handleRemoveFile(name)} />
        ))}
        {isMulti || files.length < 1 ? <FileTile accept={accept} isUpload onFileChange={handleFileChange} /> : null}
      </Flex>
    </Flex>
  )
}

export default Upload
